import { useEffect } from "react";

import { FormLayout } from "@/components/global/form/layouts/form-layout";
import Icon from "@/components/icon";

interface SuccessMessageProps {
  title: string;
}

export const SuccessMessage = ({ title }: SuccessMessageProps) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <FormLayout>
      <div className="flex flex-col items-center justify-center min-h-[400px] p-8 animate-fadeIn">
        <div className="relative flex flex-col items-center">
          <Icon
            icon="check-primary"
            className="text-success2 [&>path]:fill-success2 [&>*]:fill-success2 relative animate-scaleIn z-10"
            size={48}
          />
        </div>

        <h2 className="text-2xl font-bold text-success2 mt-8 mb-4 animate-slideUp">
          {title}
        </h2>

        <p className="text-gray-600 text-center max-w-md animate-slideUp animation-delay-100">
          La modale se fermera automatiquement dans quelques secondes...
        </p>
      </div>
    </FormLayout>
  );
};
